import { concat, connect, debounceTime as rxjs_debounceTime, MonoTypeOperatorFunction, take } from 'rxjs';

export function debounceAfterFirst<T>(debounceTime: number): MonoTypeOperatorFunction<T> {
  return connect(shared =>
    concat(
      shared.pipe(take(1)), //
      shared.pipe(rxjs_debounceTime(debounceTime))
    )
  );
}
